import { useMediaQuery } from "usehooks-ts";
import media from "../../styles/common/media.js";
export const useOnly = (key)=>{
    let string = media.only('sm')?.split('@media ')[1];
    if (key && typeof key === 'string') {
        string = media.only(key)?.split('@media ')[1];
    }
    const matches = useMediaQuery(string);
    return matches;
};
export default useOnly;

//# sourceMappingURL=useOnly.js.map